import React, { useMemo, useLayoutEffect, useCallback } from 'react';
import { connect } from 'react-redux';
import { RadioList } from '@sas/nova-commons/components/ListBox/SingleList/SingleList';
import { exposeTestId } from '../../config';
import { setConstraints } from '../../store/birdLayout/BirdLayoutState';
import { RadioListState } from '../../store/birdElement/radioListState';
import { selectBirdRadioListState, selectStyleState, selectAccessibilityLabelState, } from '../../store/selectors';
import { bindActionCreators } from 'redux';
import { useDesignTokens } from '@sas/nova-commons/theme';
import { fontStyles, longestTextWidthForValues, listStyleTokenOverrides, ItemHeightPadding, textHeight, } from '../utils/style';
import { useFontLoadedKey } from '../FontProvider';
import { SearchableList } from '../SearchableList';
const radioListItemWidthPadding = 32 /*padding*/ + 2 /*border*/ + 28; /* radio button width */
export const BirdRadioListBase = function (props) {
    const actions = props.actions;
    const { values, measureValues, selectedIndex, searchable } = props.state;
    const { font, normal } = props.style || {};
    const combinedValues = useMemo(() => {
        if (!values) {
            return;
        }
        return values.map((value, index) => {
            return {
                text: value,
                secondaryText: measureValues ? measureValues[index] : undefined,
            };
        });
    }, [values, measureValues]);
    {
        const dt = useDesignTokens();
        const fonts = useMemo(() => fontStyles(font, dt), [font, dt]);
        const uiFonts = useMemo(() => fontStyles(undefined, dt), [dt]);
        const fontKey = useFontLoadedKey(fonts.fontFamily);
        const preferredValues = props.preferredSizing ? combinedValues : undefined;
        useLayoutEffect(() => {
            const itemHeight = Math.max(18, // radio button height
            textHeight(fonts)) + ItemHeightPadding;
            const constraints = {
                minHeight: itemHeight * 2,
                minWidth: 160,
            };
            if (preferredValues) {
                constraints.preferredWidth =
                    longestTextWidthForValues(preferredValues, fonts) + radioListItemWidthPadding;
                constraints.preferredHeight = itemHeight * preferredValues.length;
                if (searchable) {
                    constraints.preferredHeight +=
                        Math.max(28, textHeight(uiFonts) + 4 /* padding */) +
                            1 /* input fudge factor */ +
                            2 /* border */ +
                            6 /* padding around */;
                }
            }
            actions.setConstraints(props.id, constraints);
        }, [
            fontKey /*(implicit)*/,
            actions,
            preferredValues,
            props.id,
            props.preferredSizing,
            fonts,
            uiFonts,
            searchable,
        ]);
    }
    const tokenOverrides = useCallback((cbProps) => {
        return listStyleTokenOverrides(cbProps, props.style);
    }, [props.style]);
    return !searchable ? (React.createElement(RadioList, { testId: exposeTestId() ? `${props.id}-RdList` : null, onSelected: (selectedIndex) => actions.update(props.id, { selectedIndex }), items: combinedValues || [], selectedIndex: selectedIndex, theme: tokenOverrides, font: font, style: {
            overflowY: 'auto',
            overflowX: 'hidden',
            height: '100%',
            backgroundColor: normal && normal.bg,
        }, ariaLabel: props.accessibilityLabel })) : (React.createElement(SearchableList, { type: "single", items: combinedValues || [], selection: selectedIndex || 0, onSelected: (selectedIndex) => {
            actions.update(props.id, { selectedIndex });
        }, renderList: (items, selectedIndex, onSelected) => (React.createElement(RadioList, { testId: exposeTestId() ? `${props.id}-RdList` : null, onSelected: onSelected, items: items, selectedIndex: selectedIndex, theme: tokenOverrides, font: font, style: {
                overflowY: 'visible',
                overflowX: 'hidden',
                height: '100%',
                backgroundColor: normal && normal.bg,
            }, ariaLabel: props.accessibilityLabel })) }));
};
export const BirdRadioList = connect((state, props) => ({
    state: selectBirdRadioListState(state, props.id),
    style: selectStyleState(state, props.id),
    accessibilityLabel: selectAccessibilityLabelState(state, props.id),
}), (dispatch) => ({
    actions: bindActionCreators(Object.assign({ setConstraints }, RadioListState.actions), dispatch),
}))(BirdRadioListBase);
